import { useFragmentVideoJsSubtitles } from './useFragmentVideoJsSubtitles';

type FragmentVideoSubtitlesAttachmentProps = {
  fragmentId: string;
  /** BCP-47 language for the text track (e.g. station `language`). */
  srclang: string;
};

/**
 * Invisible helper mounted under VideoPlaybackProvider when subtitles should be available:
 * registers VTT subtitles on the Video.js player.
 */
export function FragmentSubtitlesAttachment({
  fragmentId,
  srclang,
}: FragmentVideoSubtitlesAttachmentProps) {
  useFragmentVideoJsSubtitles(fragmentId, srclang);
  return null;
}
